import { Helmet } from 'react-helmet';
import { Redirect, 
  // useNavigate 
  useLocation
} from 'react-router-dom';
import {
  Box,
  Container,
  Grid
} from '@material-ui/core';

import LoanGen from 'src/components/applications/LoanGenerator';
import LoanCards from 'src/components/applications/LoanCards';
import moment from 'moment';


import { useEffect, useState } from 'react';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_BACKBTN  } from 'src/redux/actions/types';
import { unstable_renderSubtreeIntoContainer } from 'react-dom';

const Dashboard = () => {
    const { user } = useSelector(state => state.auth);

    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [isLoan, setLP] = useState(false);
    

    useEffect(() => {
        if(user && user.loans){
user.loans.sort((a, b) => {
  return moment(b.appliedAt).diff(a.appliedAt);
});
            setList(user.loans)
        }
    }, [  user])


        
useEffect(() => {
  dispatch({
    type: SET_BACKBTN,
    payload: '/app/dashboard'
  })
}, [])


  return(
  <>
    <Helmet>
      <title>Loan Applications | Transac</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 1
      }}
    >
      <Container maxWidth={false}>
        <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={12}
          md={12}
          xl={12}
          xs={12}
        >
         <LoanGen/>
        </Grid>
      </Grid>
      </Container>
    </Box>
  </>
);
    }

export default Dashboard;
